import { REDUCERS } from '../constants';

export const eReceiptsDetailsToggle = (state: Object, action: Object) => {
  const { receiptNumber } = action.payload;
  return {
    ...state,
    meta: {
      ...state.meta,
      [receiptNumber]: {
        ...state.meta[receiptNumber],
        isOpen: !state.meta[receiptNumber].isOpen,
      },
    },
  };
};

export const fetchEReceiptsSummarySuccess = (state: Object, action: Object) => {
  const { eReceiptsMeta, eReceipts, filters, currentFilter } = action.payload;
  return {
    meta: { ...eReceiptsMeta },
    receipts: eReceipts,
    hasLoaded: true,
    currentPage: 1,
    filters,
    currentFilter,
    currentSort: 'Date (New to Old)',
  };
};

export const fetchEReceiptsDetails = (state: Object, action: Object) => {
  const { receiptNumber } = action.payload;
  const { calledFrom } = action.meta;
  return {
    ...state,
    meta: {
      ...state.meta,
      [receiptNumber]: {
        ...state.meta[receiptNumber],
        isFetching: true,
        isOpen: calledFrom !== 'receipt',
      },
    },
  };
};

export const fetchEReceiptsDetailSuccess = (state: Object, action: Object) => {
  const { receiptNumber } = action.payload.receipt;
  return {
    ...state,
    meta: {
      ...state.meta,
      [receiptNumber]: {
        ...state.meta[receiptNumber],
        isFetching: false,
        isError: false,
      },
    },
  };
};

export const fetchEReceiptsDetailsFailure = (state: Object, action: Object) => {
  const { receiptNumber } = action.payload;
  return {
    ...state,
    meta: {
      ...state.meta,
      [receiptNumber]: {
        ...state.meta[receiptNumber],
        isFetching: false,
        isError: true,
      },
    },
  };
};
export const getEReceipts = (state: Object) =>
  state[REDUCERS.ERECEIPTS_SUMMARY] &&
  state[REDUCERS.ERECEIPTS_SUMMARY].actionData
    ? state[REDUCERS.ERECEIPTS_SUMMARY].actionData.receipts
    : [];

export const getEReceiptsSummary = (state: Object) =>
  state[REDUCERS.ERECEIPTS_SUMMARY] &&
  state[REDUCERS.ERECEIPTS_SUMMARY].actionData
    ? state[REDUCERS.ERECEIPTS_SUMMARY].actionData.meta
    : {};

export const getCurrentPage = (state: Object) =>
  state[REDUCERS.ERECEIPTS_SUMMARY] &&
  state[REDUCERS.ERECEIPTS_SUMMARY].actionData
    ? state[REDUCERS.ERECEIPTS_SUMMARY].actionData.currentPage
    : '';

export const getHasLoaded = (state: Object) =>
  state[REDUCERS.ERECEIPTS_SUMMARY] &&
  state[REDUCERS.ERECEIPTS_SUMMARY].actionData
    ? state[REDUCERS.ERECEIPTS_SUMMARY].actionData.hasLoaded
    : false;

export const getDateFilters = (state: Object) =>
  state[REDUCERS.ERECEIPTS_SUMMARY] &&
  state[REDUCERS.ERECEIPTS_SUMMARY].actionData
    ? state[REDUCERS.ERECEIPTS_SUMMARY].actionData.filters
    : [];

export const getCurrentFilter = (state: Object) =>
  state[REDUCERS.ERECEIPTS_SUMMARY] &&
  state[REDUCERS.ERECEIPTS_SUMMARY].actionData
    ? state[REDUCERS.ERECEIPTS_SUMMARY].actionData.currentFilter
    : '';

export const getCurrentSort = (state: Object) =>
  state[REDUCERS.ERECEIPTS_SUMMARY] &&
  state[REDUCERS.ERECEIPTS_SUMMARY].actionData
    ? state[REDUCERS.ERECEIPTS_SUMMARY].actionData.currentSort
    : '';

export const getEReceiptDetails = (state: Object, receiptNumber: string) =>
  state[REDUCERS.ERECEIPTS_SUMMARY] &&
  state[REDUCERS.ERECEIPTS_SUMMARY].mappedData
    ? state[REDUCERS.ERECEIPTS_SUMMARY].mappedData[receiptNumber]
    : {};

export const getEReceiptMeta = (state: Object, receiptNumber: string) =>
  state[REDUCERS.ERECEIPTS_SUMMARY] &&
  state[REDUCERS.ERECEIPTS_SUMMARY].actionData &&
  state[REDUCERS.ERECEIPTS_SUMMARY].actionData.meta
    ? state[REDUCERS.ERECEIPTS_SUMMARY].actionData.meta[receiptNumber]
    : {};
